import React from 'react'
import { useApiListAppBuildVersion } from '../../../../../../api-new/state/config'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { useParamsInt } from '../../../../../../shared/hooks/location'
import { TableAgClient } from '../../../../../../shared/table-builder/table-ag-client'
import { ColumnDateTime, ColumnMenu, ColumnSize, ColumnText, ColumnYesNo } from '../../../../../../shared/table-builder/table-columns'
import { Menu, MenuDelete, MenuEdit, MenuItem } from '../../../../../../shared/menu/menu'
import { IconCheck, IconDownload, IconRecycle, IconVersion } from '../../../../../../shared/icon/icon'
import { useRoleSysApp } from '../../../../../../role/hook/role-sys'
import { useDownloadPresign } from '../../../../../../shared/download/hook'

export const AppBuildVersionlist = () => {
  const { appID, appStoreID, appVersionID } = useParamsInt()

  const apiListAppBuildVersion = useApiListAppBuildVersion()

  const roleSysApp = useRoleSysApp()

  const { active, download } = useDownloadPresign()

  const handleReady = () => apiListAppBuildVersion.get(appVersionID)
  const handleDestroyed = () => apiListAppBuildVersion.init()

  const handleSetCurrent = async id => {
    await apiListAppBuildVersion.put(`${id}/current`)
    await apiListAppBuildVersion.get(appVersionID)
  }

  const handleDownload = async id => {
    let presigned = await apiListAppBuildVersion.get(`${id}/presigned-download`)
    download(presigned.url)
  }

  const handleDelete = async id => {
    await apiListAppBuildVersion.delete(id)
    await apiListAppBuildVersion.get(appVersionID)
  }

  const HeaderMenu = () =>
    <Menu>
      <MenuItem
        Icon={IconRecycle}
        text="recycle"
        to={`/admin/app/edit/${appID}/store/edit/${appStoreID}/version/edit/${appVersionID}/version/recycle`}
        show={roleSysApp.accessDelete}
      />
    </Menu>

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconVersion} text="versions">
        <CardFullHeightScrollY title="app store versions" HeaderMenu={HeaderMenu}>
          <TableAgClient apiList={apiListAppBuildVersion} onReady={handleReady} onDestoryed={handleDestroyed}>
            <ColumnDateTime field="createdAt" />
            <ColumnText field="filename" />
            <ColumnText field="storageKey" />
            <ColumnSize field="contentLength" />
            <ColumnYesNo field="isCurrent" />
            <ColumnText field="uploadedBy" />
            <ColumnText field="note" />
            <ColumnMenu
              menu={row =>
                <Menu small>
                  <MenuItem Icon={IconCheck} text="set current" onClick={() => handleSetCurrent(row.id)} show={roleSysApp.accessUpdate} />
                  <MenuItem Icon={IconDownload} text="download" onClick={() => handleDownload(row.id)} show={roleSysApp.accessRead} disabled={active} />
                  <MenuEdit
                    to={`/admin/app/edit/${appID}/store/edit/${appStoreID}/version/edit/${appVersionID}/version/edit/${row.id}`}
                    show={roleSysApp.accessUpdate}
                  />
                  <MenuDelete onClick={() => handleDelete(row.id)} show={roleSysApp.accessDelete} />
                </Menu>}
            />
          </TableAgClient>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
